import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function ticketReducer(state = initialState.ticketData, action) {
  switch (action.type) {
    case types.LOADED_TICKET_DATA_SUCCESS:
      return action.ticketData;
    default:
      return state;
  }
}
